import apiClient from './apiClient';

export default async function fetchAuthenticatedFromBackend<T>(path: string): Promise<T> {
  const response = await apiClient.get<T>(`/${path}`);
  return response.data;
}
